import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rvb',
  templateUrl: './rvb.component.html',
  styleUrls: ['./rvb.component.scss'],
})
export class RvbComponent implements OnInit {

  rouge = "#ff0000";
  bleu = "#0000ff";
  vert = "#00ff00";

  rougedec = 255;
  vertdec = 255;
  bleudec = 255;
  couleurdec : string;
  couleurhex : string;
  couleurbin : string;
  
  
  rougehex :string;
  verthex  :string;
  bleuhex  :string;

  rougebin :string;
  vertbin  :string;
  bleubin  :string;

  
  
  constructor() { }

  ngOnInit() {
    this.valchange();
  }

  valchange() {
    this.rougehex = this.hexa(this.rougedec);
    this.rougebin = this.binaire(this.rougedec);
    this.rouge = "#"+this.rougehex+"0000";
    
    this.verthex = this.hexa(this.vertdec);
    this.vertbin = this.binaire(this.vertdec);
    this.vert = "#00"+this.verthex+"00";

    this.bleuhex = this.hexa(this.bleudec);
    this.bleubin = this.binaire(this.bleudec);
    this.bleu = "#0000"+this.bleuhex;
    
    this.couleurbin = this.rougebin+this.vertbin+this.bleubin;
    this.couleurdec = "rgb("+this.rougedec+","+this.vertdec+","+this.bleudec+")";
    this.couleurhex = "#"+this.rougehex+this.verthex+this.bleuhex;
    
    
    

  }

  hexa(valeur:number) :string {
      let convertion = valeur.toString(16);
      if (convertion.length==1) convertion="0"+convertion; 
      return convertion;
  }

  binaire(valeur:number) :string {
    let convertion = valeur.toString(2);
    let lg = convertion.length;
    for (let i = lg; i < 8; i++) {
      convertion = "0"+convertion;
    } 
    return convertion;
  }

  

}
